module.exports = __webpack_public_path__ + "images/DPB2_2.08767bdd85f12618429fd57c4faeb6e2.png";